"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.Input = exports.Wrapper = void 0;

var _calendar = _interopRequireDefault(require("@remote-com/norma/icons/calendar.svg"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "DatePickerstyled__Wrapper",
  componentId: "sc-1d9wo33-0"
})(["position:relative;.react-datepicker-popper{isolation:isolate;z-index:1;}"]);

exports.Wrapper = Wrapper;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "DatePickerstyled__Input",
  componentId: "sc-1d9wo33-1"
})(["", " padding-right:40px;"], _style.InputStyle);

exports.Input = Input;
var Icon = (0, _styledComponents["default"])(_calendar["default"]).withConfig({
  displayName: "DatePickerstyled__Icon",
  componentId: "sc-1d9wo33-2"
})(["", " fill:var(--iconColor);pointer-events:none;position:absolute;right:8px;top:4px;transition:all 0.2s;opacity:var(--iconOpacity);", ":hover &,", ":focus-within &{fill:var(--iconColorHover);opacity:1;}"], function (_ref) {
  var theme = _ref.theme;

  switch (theme.mode) {
    case 'dark':
      return (0, _styledComponents.css)(["--iconColor:var(--colors-bayoux);--iconColorHover:var(--colors-irisBlue);--iconOpacity:1;"]);

    default:
      return (0, _styledComponents.css)(["--iconColor:var(--colors-blank);--iconColorHover:var(--colors-blank);--iconOpacity:0.3;"]);
  }
}, Wrapper, Wrapper);
exports.Icon = Icon;